import './Previes.scss';
import useHyreadPreview from '../../Hooks/useHyreadPreview.jsx';
import { Icon, Loader } from 'semantic-ui-react';
import { useNavigate } from 'react-router-dom';

const Preview = () => {
  const { previewBooks, error } = useHyreadPreview();
  const navigation = useNavigate();

  return error ? (
    <div className="load-preview-error">
      <Icon name="exclamation" />
      <div className="content">載入錯誤，請重新整理或稍後再試</div>
    </div>
  ) : !previewBooks.length ? (
    <div className="preview-loader">
      <Loader active inline />
    </div>
  ) : (
    <div className="preview-container">
      {previewBooks.map((book, index) => (
        <div key={index} className="preview-book">
          <img
            src={book.cover}
            fallbackSrc="https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg"
            onClick={() => {
              navigation(`/result?book=${book.title.substring(0, 8)}`);
            }}
            style={{ cursor: 'pointer' }}
          />
          <br />
          <p>
            <b>{book.title}</b>
          </p>
        </div>
      ))}
    </div>
  );
};

export default Preview;
